export class ReadAllNotifications {
    public static readonly type = '[Notifications] Read all notifications';
}
